import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { initNativePush, initDeepLinks, promptBiometricUnlock, isNative } from "@/native";

/**
 * Bootstraps native-only integrations (push, deep links, biometric re-auth)
 * once the router is mounted. Renders nothing and no-ops on the web.
 */
export function NativeBootstrap() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isNative()) return;

    void promptBiometricUnlock();
    void initNativePush((path) => navigate(path));
    const cleanup = initDeepLinks((path) => navigate(path));
    return cleanup;
  }, [navigate]);

  return null;
}
